export const slider = {
  // prevent cutting children shadows
  '.swiper.swiper-initialized': {
    marginInline: '-10px',
    padding: '10px'
  }
};
